import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { useAuth } from "@/context/AuthContext";
import { errorMessage } from "@/lib/api";
import { AuthShell, FormError, PASSWORD_HINT } from "@/components/auth/AuthShell";

const FIELDS = [
  ["company_name", "Nome da empresa", "text", "Ex.: Potabiliza Engenharia"],
  ["owner_name", "Seu nome", "text", "Quem vai usar a conta"],
  ["phone", "WhatsApp da empresa", "tel", "(00) 00000-0000"],
  ["email", "E-mail", "email", "voce@empresa.com"],
  ["password", "Senha", "password", ""],
];

export default function Signup() {
  const { register } = useAuth();
  const [f, setF] = useState({ company_name: "", owner_name: "", phone: "", email: "", password: "", accept_terms: false });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!f.accept_terms) return setError("Aceite os Termos de Uso e a Política de Privacidade para continuar.");
    setLoading(true);
    try {
      await register(f);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Criar conta grátis" subtitle="7 dias grátis, sem cartão. Depois, R$ 79,90 por mês." testid="signup-page">
      <form onSubmit={submit} className="space-y-4" data-testid="signup-form">
        {FIELDS.map(([k, label, type, ph]) => (
          <div key={k} className="space-y-1.5">
            <Label htmlFor={`su_${k}`}>{label}</Label>
            <Input id={`su_${k}`} type={type} required={k !== "phone"} placeholder={ph} value={f[k]} autoComplete={k === "password" ? "new-password" : undefined}
              onChange={(e) => setF({ ...f, [k]: e.target.value })} className="h-11 bg-slate-950" data-testid={`signup-${k.replace("_", "-")}-input`} />
            {k === "password" && <p className="text-xs text-slate-500">{PASSWORD_HINT}</p>}
          </div>
        ))}
        <label className="flex items-start gap-2 text-sm text-slate-300" htmlFor="su_terms">
          <Checkbox id="su_terms" checked={f.accept_terms} onCheckedChange={(v) => setF({ ...f, accept_terms: !!v })} className="mt-0.5" data-testid="signup-terms-checkbox" />
          <span>Li e aceito os <Link to="/termos" target="_blank" className="underline">Termos de Uso</Link> e a <Link to="/privacidade" target="_blank" className="underline">Política de Privacidade</Link>.</span>
        </label>
        <FormError error={error} />
        <Button type="submit" disabled={loading} className="h-11 w-full rounded-full font-semibold" data-testid="signup-submit-button">
          {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Criar minha conta
        </Button>
        <p className="text-center text-sm text-slate-400">Já tem conta? <Link to="/login" className="font-semibold text-slate-100 underline" data-testid="signup-login-link">Entrar</Link></p>
      </form>
    </AuthShell>
  );
}
